<h3>Password Recovery</h3>
<form [formGroup]="challengeForm" (ngSubmit)="onSubmit()" fxLayout="column">
  <mat-form-field appearance="outline">
    <mat-label>Email</mat-label>
    <input matInput placeholder="Email" formControlName="username">
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Recovery Code</mat-label>
    <input matInput placeholder="Recovery Code" formControlName="code">
  </mat-form-field>
  <div class="footer" fxLayoutAlign="flex-end center">
    <button type="submit" mat-raised-button color="primary" [disabled]="challengeForm.invalid || showProgressBar">Submit</button>
  </div>
</form>
<div class="progressbar" *ngIf="showProgressBar">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
